const sd = require('silly-datetime');

export function giveRouter(isAdmin) {
    // 分配路由
    let navs = [];
    if (isAdmin) {
        navs = [{
            title: "核查处置",
            par_index: "1",
            child_items: [{
                index: "/index",
                name: "任务列表",
                url: "/index",
                icon: 'el-icon-s-order'
            }]
        }, {
            title: "通用任务",
            par_index: "2",
            child_items: [{
                index: "/common",
                name: "任务列表",
                url: "/common",
                icon: 'el-icon-s-order'
            }]
        }, {
            title: "管理",
            par_index: "3",
            child_items: [{
                index: "/user",
                name: "用户管理",
                url: "/user",
                icon: 'el-icon-s-custom'
            }]
        }]
    } else {
        navs = [{
            title: "核查处置",
            par_index: "1",
            child_items: [{
                index: "/index",
                name: "任务列表",
                url: "/index",
                icon: 'el-icon-s-order'
            }]
        }, {
            title: "通用任务",
            par_index: "2",
            child_items: [{
                index: "/common",
                name: "任务列表",
                url: "/common",
                icon: 'el-icon-s-order'
            }]
        }]
    }
    return navs
}

export function checkSizeAndType(arr) { //图片上传
    const types = ["image/png", "image/jpg", "image/jpeg"];
    const maxSize = 5; //5mb
    let legalType = false;
    let size = 0;
    arr.forEach(element => {
        size += element.size;
        legalType = types.some(item => item == (element.raw ? element.raw.type : element.type))
    });
    if (!legalType) {
        return { flag: false, msg: '文件格式不合法！' }
    } else if (!(size / 1024 / 1024 < maxSize)) {
        return { flag: false, msg: '请控制在5M以下！' }
    } else {
        return { flag: true, msg: '' };
    }
}

export function checkSizeAndType1(arr) { //图片和文件上传
    const types = ["application/pdf", "image/png", "image/jpg", "image/jpeg", 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword', 'application/vnd.ms-excel'];
    const maxSize = 20; //20mb
    let legalType = false;
    let size = 0;
    arr.forEach(element => {
        size += element.size;
        legalType = types.some(item => item == (element.raw ? element.raw.type : element.type))
    });
    if (!legalType) {
        return { flag: false, msg: '文件格式不合法！' }
    } else if (!(size / 1024 / 1024 < maxSize)) {
        return { flag: false, msg: '请控制在20M以下！' }
    } else {
        return { flag: true, msg: '' };
    }
}

export function checkSizeAndType2(arr) { //图片和文件上传
    const types = ["application/pdf", "image/png", "image/jpg", "image/jpeg", 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword', 'application/vnd.ms-excel'];
    const maxSize = 100; //20mb
    let legalType = false;
    let size = 0;
    arr.forEach(element => {
        size += element.size;
        legalType = types.some(item => item == (element.raw ? element.raw.type : element.type))
    });
    if (!legalType) {
        return { flag: false, msg: '文件格式不合法！' }
    } else if (!(size / 1024 / 1024 < maxSize)) {
        return { flag: false, msg: '请控制在100M以下！' }
    } else {
        return { flag: true, msg: '' };
    }
}

export function sillyDatetime() { //获取今天的日期
    return sd.format(new Date(), 'YYYY-MM-DD');
}

export function sillyDatetimeHM(){
    return sd.format(new Date(),"YYYY-MM-DD HH:mm")
}


// WEBPACK FOOTER //
// ./src/utils/index.js